(function () {
  'use strict';

  function publish(name, payload) {
    var detail = Object.assign({ event: name }, payload || {});

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(name, payload || {});
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('pigment:analytics', { detail: detail }));
  }

  function productContext() {
    var product = document.querySelector('[data-product-id]');
    return product
      ? {
          product_id: product.dataset.productId || null,
          variant_id: product.dataset.variantId || null,
          product_title: product.dataset.productTitle || null,
          product_url: product.dataset.productUrl || window.location.pathname,
        }
      : { product_url: window.location.pathname };
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (/\/products\//.test(window.location.pathname)) {
      publish('product_view', productContext());
    }

    document.addEventListener(
      'click',
      function (event) {
        var heroCta = event.target.closest('[data-hero-cta]');
        if (heroCta) {
          var slide = heroCta.closest('[data-slide]');
          publish('hero_slide_click', {
            slide_title: slide ? slide.dataset.title || slide.getAttribute('aria-label') || '' : '',
            destination: heroCta.href || '',
          });
        }

        var removeControl = event.target.closest(
          '[data-in-cart], [data-cart-remove], [data-remove-line-item]',
        );
        if (removeControl) {
          publish('cart_item_remove', {
            variant_id: removeControl.dataset.variantId || null,
            product_id: removeControl.dataset.productId || null,
            product_title: removeControl.dataset.productTitle || null,
          });
        }
      },
      true,
    );
  });
})();
